import { render, staticRenderFns } from "./AddonGroup.vue?vue&type=template&id=74560ffe"
import script from "./AddonGroup.vue?vue&type=script&lang=js"
export * from "./AddonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports